
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/parking/bookings",
      function () {
        return require("private-next-pages/[locale]/parking/bookings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/parking/bookings"])
      });
    }
  